import React from 'react';
import { Text, Link, Subtitle1, Divider } from '@fluentui/react-components';

interface WelcomeSectionProps {
  privacyPolicyUrl?: string;
}

export const WelcomeSection: React.FC<WelcomeSectionProps> = ({ privacyPolicyUrl }) => {
  const welcomeTextPrefix1 = 
    `Your space for practical support, growth, and performance — all in the flow of work.`;
  const welcomeTextPrefix2 = 
    `You'll hear from Groov now and then, always to help you get more from your day and your work. 
    Your privacy is our priority.`;

  return (
    <>
    <Subtitle1 >Welcome to Groov</Subtitle1>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {welcomeTextPrefix1}
      </Text>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {welcomeTextPrefix2}
        {privacyPolicyUrl ? (
          <>
            {' '}View our{' '}
            <Link href={privacyPolicyUrl} target="_blank" rel="noreferrer">
              Privacy Policy
            </Link>
            .
          </>
        ) : (
          ' View our Privacy Policy.'
        )}
     </Text>
     <br/>
     <Divider />
    </>
  );
};

